import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Breadcrumb, Heading } from 'vet-bones/design-system/components';

import {
  ORGANIZATION_DASHBOARD_BREADCRUMB_ORG,
  ORGANIZATION_SDU_DASHBOARD_HEADING,
} from 'src/ui/constants/testIds';
import { SduDashboardBody } from 'src/ui/containers/sdu-dashboard/SduDashboardBody';
import { graphQLClient } from 'src/ui/graph/graphQLClient';
import {
  Connection,
  useListOrganizationConnectionsQuery,
} from 'src/ui/graph/types';
import { useOrganization } from 'src/ui/hooks/organization';
import * as copy from 'src/ui/templates/copy';
import { buildDashboardRoute } from 'src/ui/utils/buildRoute';

export const OrganizationSduDashboard: React.VFC = () => {
  const history = useHistory();
  const { org } = useParams<{ org: string }>();

  const { organization } = useOrganization(org);

  const { data } = useListOrganizationConnectionsQuery(graphQLClient, {
    org_domain: org,
  });

  const connections: Connection[] = (data?.listConnections ?? []).filter(
    (c): c is NonNullable<typeof c> => c !== null
  );

  if (!organization) {
    return null;
  }

  return (
    <div className="organization-dashboard">
      <div className="organization-dashboard-header">
        <div className="organization-dashboard-header-info">
          <Heading
            size="xl"
            testId={ORGANIZATION_SDU_DASHBOARD_HEADING}
            weight="semibold"
          >
            {organization.name}
          </Heading>
          <Breadcrumb
            items={[
              {
                id: 'org',
                onClick: () => history.push(buildDashboardRoute(org)),
                testId: ORGANIZATION_DASHBOARD_BREADCRUMB_ORG,
                text: organization.name,
              },
              {
                id: 'units',
                text: copy.components.organization.dashboard.breadcrumb.units,
              },
            ]}
          />
        </div>
      </div>

      <SduDashboardBody
        connections={connections}
        onEndpointClick={(row) => {
          history.push(buildDashboardRoute(org, 'units', row.endpointId));
        }}
        orgDomain={org}
      />
    </div>
  );
};
